// ログイン後の戻り先（招待リンク等）を一時保存する薄いラッパ。
// state（React Router の history.state）が失われるケース
// ―ハードリロード・OAuth リダイレクト・別ブラウザでの開き直し（LINE内ブラウザ
//   →外部ブラウザ）・401 ハード遷移― の保険として sessionStorage に退避する。
const KEY = 'redirectAfterLogin'

export const saveRedirect = (path: string): void => sessionStorage.setItem(KEY, path)
export const readRedirect = (): string | null => sessionStorage.getItem(KEY)
export const clearRedirect = (): void => sessionStorage.removeItem(KEY)
